<template>
  <div v-if="showModal" class="side__modal opened">
    <div class="side__modal__content">
      <div class="modal__top">
        <div class="modal__header">
          <h3 class="modal__title">{{ $lang.app.COST_CALCULATION }}</h3>
          <span class="modal__close" @click="closeModal">
          <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
        </div>
      </div>

      <Form v-if="form" class="modal__footer"
            @submit="submit" :initial-values="form">

        <div class="rounded-lg border border-solid border-gray-200 py-2 px-4 mb-4">

          <div class="input__group input__add__info">
            <label :for="`expert-purpose-type-category-input`" class="label">{{ $lang.app.PURPOSE_OF_OBJECT }}</label>
            <div class="select__wrapper">
              <Field :name="`expertPurposeTypeCategory`" v-slot="{ field, errorMessage }">
                <Multiselect
                    :id="`expert-purpose-type-category-input`"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="form.expertPurposeTypeCategory"
                    :options="helper.expertPurposeTypeCategoryOptions"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>

          <div class="input__group input__add__info">
            <label :for="`expert-purpose-type-input`" class="label">{{ $lang.app.PURPOSE_OF_OBJECT_TYPE }}</label>
            <div class="select__wrapper">
              <Field :name="`expertPurposeType`" v-slot="{ field, errorMessage }">
                <Multiselect
                    :id="`expert-purpose-type-input`"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="form.expertPurposeType"
                    :options="helper.expertPurposeTypeOptions"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>

          <div class="input__group">
            <label :for="`description-input`" class="label">{{ $lang.app.NAME_OF_CALCULATION }}</label>
            <Field :name="`description`" v-slot="{ field, errorMessage }">
              <input v-bind="field"
                     type="text"
                     :id="`description-input`"
                     v-model="form.description"
                     class="input"
                     :class="{'input--fail': errorMessage }"
                     :placeholder="$lang.app.ENTER">
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>

          <div class="flex">
            <div class="w-1/2 pr-1">
              <div class="input__group">
                <label :for="`value-input`" class="label">{{ $lang.app.VALUE }}</label>
                <Field :name="`value`" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="number"
                         :id="`value-input`"
                         v-model="form.value"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="w-1/2 pl-1">
              <div class="input__group input__add__info">
                <label :for="`unit-of-measurement-input`" class="label">{{ $lang.app.UNIT_OF_MEASUREMENT }}</label>
                <div class="select__wrapper">
                  <Field :name="`unitOfMeasurement`" v-slot="{ field, errorMessage }">
                    <Multiselect
                        :id="`unit-of-measurement-input`"
                        :class="{'select--fail': errorMessage }"
                        v-bind="field"
                        v-model="form.unitOfMeasurement"
                        :options="helper.unitOfMeasurements"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND"
                        :can-clear="false">
                    </Multiselect>
                    <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                  </Field>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="between__buttons">
          <button type="button" class="button button__modal__close button--cancel"
                  @click="closeModal">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="relative button button__modal__close"
                  :disabled="submitting">
            {{ $lang.app.UPDATE }}
            <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
              <div class="block animate-spin">
                <RefreshIcon class="w-6 h-6 mirror-y"/>
              </div>
            </div>
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import {Form, Field} from 'vee-validate'
import paymentApi from "../../../../../api/employee/payment";
import expertPurposeTypeCategoryApi from "../../../../../api/employee/expertPurposeTypeCategory";
import expertPurposeTypeApi from "../../../../../api/employee/expertPurposeType";
import unitOfMeasurementApi from "../../../../../api/ref/unitOfMeasurement";

export default {
  components: {
    Form, Field,
  },
  data() {
    return {
      showModal: false,

      resolution: null,
      payment: null,

      helper: {
        expertPurposeTypeCategoryOptions: [],
        expertPurposeTypeOptions: [],
        unitOfMeasurements: [],
      },

      submitting: false,
      form: null,
    };
  },
  created() {
    this.fetchExpertPurposeTypeCategoryOptions()
    this.fetchUnitOfMeasurement()
  },
  watch: {
    'form.expertPurposeTypeCategory'(value) {
      if(value) {
        this.fetchExpertPurposeTypeOptions(value)
      }
    },
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    fetchExpertPurposeTypeCategoryOptions() {
      expertPurposeTypeCategoryApi.getExpertPurposeTypeCategories().then(res => {
        this.helper.expertPurposeTypeCategoryOptions = res.map(item => ({
          value: item.id,
          label: item.title
        }))
      })
    },
    fetchExpertPurposeTypeOptions(expertPurposeTypeCategoryId) {
      expertPurposeTypeApi.getExpertPurposeTypeCategoryExpertPurposeTypes(expertPurposeTypeCategoryId)
          .then(res => {
            this.helper.expertPurposeTypeOptions = res.map(item => ({
              value: item.id,
              label: item.title
            }))
          })
    },
    fetchUnitOfMeasurement() {
      unitOfMeasurementApi.getUnitOfMeasurements()
          .then(res => {
            this.helper.unitOfMeasurements = res.map(item => ({
              value: item.id,
              label: item.name
            }))
          })
    },
    fetchPayment(payment) {
      paymentApi.getPayment(payment.id).then(({data}) => {
        this.payment = data
        this.form = {
          expertPurposeTypeCategory: data.expertPurposeType.category.id,
          expertPurposeType: data.expertPurposeType.id,
          value: data.value,
          unitOfMeasurement: data.unitOfMeasurement.id,
          description: data.description
        }
      })
    },
    submit(values, actions) {
      this.submitting = true
      paymentApi
          .updatePayment(this.resolution.id, this.payment.id, {
            expertPurposeType: this.form.expertPurposeType,
            unitOfMeasurement: this.form.unitOfMeasurement,
            value: this.form.value,
            description: this.form.description
          })
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refreshSectionPayments')
            this.$emitter.emit('refresh-resolutions', {reload: false})
            this.$emitter.emit('refresh-resolution', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          }).catch(error => {
        if(error.response.data.status === 422) {
          this.setValidationErrors(actions, error.response.data.errors)
        } else {
          this.$snotify.error(error)
        }
      })
          .finally(() => {
            this.submitting = false
          });
    }
  },
  beforeMount() {
    this.$emitter.on('openEditPaymentModal', ({resolution, payment}) => {
      this.resolution = resolution
      this.fetchPayment(payment)
      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('openEditPaymentModal')
  }
}
</script>
<style>
.side-modal-body {
  height: calc(100vh - 164px);
}
</style>
